export enum EntitiesEnum{
    Reseller = 'reseller',
    Business = 'business',
    Location = 'location'
}